import * as parse from '@babel/parser';
import * as baseFormula from "../constants/formula";
import { Base_Date_Format_Options as Date_Format_Options } from "../constants/prop";
const DateLabelMap = {};
const DateFormulaMap = {};
for (const prop of Date_Format_Options) {
  DateLabelMap[prop.label] = prop.formula;
  DateFormulaMap[prop.formula] = prop.label;
}
const formula = {
  ...baseFormula,
  DATE: (a, b) => ({
    type: 'formula',
    formula: {
      op: 'date',
      input: [a, DateLabelMap[b] ?? b]
    }
  })
};
for (const key of Object.keys(formula)) {
  if (key === key.toUpperCase()) {
    formula[key.toLowerCase()] = formula[key];
  }
}
const specialMap = {
  当前时间: formula.NOW(),
  创建者: formula.NICK_NAME(formula.PROP(-1)),
  创建日期: formula.CREATE_TIME(),
  创建时间: formula.CREATE_TIME(),
  当前状态: formula.STATUS_NAME()
};
const statusPropMap = {
  负责人: 0,
  参与者: 1,
  开始时间: 2,
  结束时间: 3,
  备注: 4,
  0: '负责人',
  1: '参与者',
  2: '开始时间',
  3: '结束时间',
  4: '备注'
};
const opLevel = {
  // or: 8,
  // and: 7,
  // not: 6,
  great: 5,
  less: 5,
  great_equal: 5,
  less_equal: 5,
  equal: 5,
  not_equal: 5,
  add: 4,
  subtract: 4,
  multiply: 3,
  divide: 3,
  mod: 3
};
function getIdMap(temp_info) {
  const ret = {
    创建者: -1,
    标题: -3
  };
  for (let i = 0; i < temp_info.prop.length; i++) {
    if (temp_info.prop[i].name) ret[temp_info.prop[i].name] = i;
  }
  return ret;
}
const sPropNameSet = new Set([0, 1]);
function getNameSet(temp_info) {
  const ret = new Set();
  ret.add(-1);
  for (let i = 0; i < temp_info.prop.length; i++) {
    if (temp_info.prop[i]?.type === 'user') {
      ret.add(i);
    }
  }
  return ret;
}
function getSiMap(temp_info) {
  const ret = {};
  for (let i = 0; i < temp_info.task_status.length; i++) {
    if (temp_info.task_status[i].name) ret[temp_info.task_status[i].name] = i;
  }
  return ret;
}
function QUOTA(idMap, nameSet, templateList, temp_id, prop, remoteProp, quotaProp, si = null, parentId = null) {
  temp_id = temp_id.arguments?.[0]?.value ?? temp_id.name;
  const temp_info = templateList.find(n => n.name === temp_id);
  if (!temp_info) throw new Error(`找不到模板“${temp_id}”`);
  const idMap2 = getIdMap(temp_info);
  const nameSet2 = getNameSet(temp_info);
  if (prop.type !== 'ArrayExpression') throw new Error(`QUOTA的第二个参数期望是数组， 当前类型是${prop.type}`);
  prop.elements = prop.elements.map(n => n.type === 'CallExpression' ? n.arguments[0] : n);
  if (remoteProp.type !== 'ArrayExpression') throw new Error(`QUOTA的第三个参数期望是数组， 当前类型是${prop.type}`);
  remoteProp.elements = remoteProp.elements.map(n => n.type === 'CallExpression' ? n.arguments[0] : n);
  if (quotaProp.type === 'CallExpression') quotaProp = quotaProp.arguments[0];
  if (quotaProp.type !== 'Identifier' && quotaProp.type !== 'StringLiteral') throw new Error(`QUOTA的第四个参数期望是标识符或者字符串， 当前类型是${prop.type}`);
  if (!((quotaProp.name ?? quotaProp.value) in idMap2)) throw new Error(`找不到引用的属性“${quotaProp.name ?? quotaProp.value}”`);
  if (si !== null) {
    const siMap = getSiMap(temp_info);
    if (si.type === 'CallExpression') si = si.arguments[0];
    switch (si.type) {
      case 'ArrayExpression':
        si = si.elements.map(n => {
          if (n.type === 'CallExpression') n = n.arguments[0];
          if (!((n.name ?? n.value) in siMap)) throw new Error(`没有找到状态${n.name ?? n.value}`);
          return siMap[n.name ?? n.value];
        });
        break;
      case 'Identifier':
        if (!(si.name in siMap)) throw new Error(`没有找到状态${si.name}`);
        si = [siMap[si.name]];
        break;
      case 'StringLiteral':
        if (!(si.value in siMap)) throw new Error(`没有找到状态${si.value}`);
        si = [siMap[si.value]];
        break;
      case 'NumericLiteral':
        if (!Object.values(siMap).includes(si.value)) throw new Error(`没有找到状态${si.value}`);
        si = si.value;
        break;
      default:
        throw new Error(`不支持的状态类型，期望是数字、字符串或者标识符，当前类型是${si.type}`);
    }
  }
  const ret = formula.QUOTA(temp_info.template_id.toString('hex').toUpperCase(), prop.elements.map(n => {
    if ((n.name ?? n.value) in idMap) return idMap[n.name ?? n.value];
    throw new Error(`找不到属性${n.name ?? n.value}`);
  }), remoteProp.elements.map(n => {
    if ((n.name ?? n.value) in idMap2) return idMap2[n.name ?? n.value];
    throw new Error(`找不到属性${n.name ?? n.value}`);
  }), idMap2[quotaProp.name ?? quotaProp.value], si);
  if (nameSet2.has(idMap2[quotaProp.name ?? quotaProp.value])) {
    return formula.NICK_NAME(ret);
  }
  return ret;
}
function treeToFormula(tree, templateList, idMap, nameSet) {
  switch (tree.type) {
    case 'UnaryExpression':
      switch (tree.operator) {
        case '!':
          return formula.NOT(treeToFormula(tree.argument, templateList, idMap, nameSet));
        case '-':
          return -treeToFormula(tree.argument, templateList, idMap, nameSet);
        default:
          throw new Error(`不支持的运算符${tree.operator}`);
      }
    case 'BinaryExpression':
    case 'LogicalExpression':
      switch (tree.operator) {
        case '+':
          return formula.ADD(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '-':
          return formula.SUB(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '*':
          return formula.MUL(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '/':
          return formula.DIV(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '%':
          return formula.MOD(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '||':
          return formula.OR(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '&&':
          return formula.AND(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '>':
          return formula.GREAT(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '<':
          return formula.LESS(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '>=':
          return formula.GREAT_EQUAL(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '<=':
          return formula.LESS_EQUAL(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '==':
          return formula.EQUAL(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        case '!=':
          return formula.NOT_EQUAL(treeToFormula(tree.left, templateList, idMap, nameSet), treeToFormula(tree.right, templateList, idMap, nameSet));
        default:
          throw new Error(`不支持的运算符${tree.operator}`);
      }
    case 'ConditionalExpression':
      return formula.IF(treeToFormula(tree.test, templateList, idMap, nameSet), treeToFormula(tree.consequent, templateList, idMap, nameSet), treeToFormula(tree.alternate, templateList, idMap, nameSet));
    case 'CallExpression':
      if (tree.callee.type === 'Identifier' && (tree.callee.name in formula || tree.callee.name === 'MAP_PROP')) {
        switch (tree.callee.name) {
          case 'MAP_PROP':
            if (tree.arguments[0]?.type !== 'StringLiteral') throw new Error(`不支持类型为“${tree.arguments[0]?.type}”的属性`);
            if (tree.arguments[0].value in specialMap) {
              return specialMap[tree.arguments[0].value];
            } else if (tree.arguments[0].value in idMap) {
              if (nameSet.has(idMap[tree.arguments[0].value])) {
                return formula.NICK_NAME(formula.PROP(idMap[tree.arguments[0].value]));
              } else {
                return formula.PROP(idMap[tree.arguments[0].value]);
              }
            } else if (tree.arguments[0].value in statusPropMap) {
              if (statusPropMap[tree.arguments[0].value] <= 1) {
                return formula.NICK_NAME(formula.STATUS_PROP(statusPropMap[tree.arguments[0].value]));
              } else {
                return formula.STATUS_PROP(statusPropMap[tree.arguments[0].value]);
              }
            }
            throw new Error(`找不到标识符“${tree.arguments[0].value}”对应的属性`);
          case 'QUOTA':
          case 'QUOTE':
            // @ts-ignore
            return QUOTA(idMap, nameSet, templateList, ...tree.arguments);
          case 'STATUS_PROP':
            if (tree.arguments.length === 0) {
              throw new Error(`STATUS_PROP缺少参数`);
            }
            if (tree.arguments.length > 1) {
              throw new Error(`STATUS_PROP参数过多，应该是1个`);
            }
            if ((tree.arguments[0].name ?? tree.arguments[0].value) in statusPropMap) {
              if (statusPropMap[tree.arguments[0].name ?? tree.arguments[0].value] <= 1) {
                return formula.NICK_NAME(formula.STATUS_PROP(statusPropMap[tree.arguments[0].name ?? tree.arguments[0].value]));
              } else {
                return formula.STATUS_PROP(statusPropMap[tree.arguments[0].name ?? tree.arguments[0].value]);
              }
            }
            throw new Error(`找不到状态属性“${tree.arguments[0].name ?? tree.arguments[0].value}”`);
          case 'CONST':
            if (tree.arguments[0].type !== 'StringLiteral' && tree.arguments[0].type !== 'NumericLiteral' && tree.arguments[0].type !== 'NullLiteral') throw new Error(`不支持的常量类型${tree.arguments[0].type}`);
            if (tree.arguments[0].type === 'NullLiteral') {
              return formula.CONST(null);
            } else if (typeof tree.arguments[0].value === 'string' || typeof tree.arguments[0].value === 'number') {
              return formula.CONST(tree.arguments[0].value);
            }
            throw new Error(`不支持的常量类型${typeof tree.arguments[0].value}`);
          default:
            return formula[tree.callee.name](...tree.arguments.map(n => treeToFormula(n, templateList, idMap, nameSet)));
        }
      }
      throw new Error(`找不到函数${tree.callee.name}`);
    case 'Identifier':
    case 'NumericLiteral':
    case 'StringLiteral':
      return tree.value;
    default:
      throw new Error(`不支持的公式类型${tree.type}`);
  }
}
export function stringToFormula(s, templateList, template_id) {
  const idMap = getIdMap(templateList.find(n => n.template_id === template_id));
  const nameSet = getNameSet(templateList.find(n => n.template_id === template_id));
  let ns = '';
  let double_inner = false;
  let single_inner = false;
  for (let i = 0; i < s.length; i++) {
    switch (s[i]) {
      case '{':
        if (double_inner || single_inner) {
          ns += s[i];
        } else {
          ns += 'MAP_PROP("';
        }
        break;
      case '}':
        if (double_inner || single_inner) {
          ns += s[i];
        } else {
          ns += '")';
        }
        break;
      case '"':
        if (s[i - 1] !== '\\' && !single_inner) {
          double_inner = !double_inner;
        }
        ns += s[i];
        break;
      case "'":
        if (s[i - 1] !== '\\' && !double_inner) {
          single_inner = !single_inner;
        }
        ns += s[i];
        break;
      default:
        ns += s[i];
    }
  }
  s = ns;
  const tree = parse.parseExpression(s);
  // @ts-ignore
  if (tree.code === 'BABEL_PARSER_SYNTAX_ERROR') {
    throw new Error('格式错误');
  }
  const ret = treeToFormula(tree, templateList, idMap, nameSet);
  if (ret.type === 'formula') {
    return ret;
  }
  return formula.PASS_ANY(ret);
}
const DataSymbol = {
  create_time: Symbol('create_time')
};
export function formulaToString(formula, templateList, template_id) {
  if (formula.type === 'formula') return formulaToString(formula.formula, templateList, template_id);
  const templateMap = {};
  for (let i = 0; i < templateList.length; i++) {
    templateMap[templateList[i].template_id ? templateList[i].template_id : templateList[i].temp_id.toString('hex').toUpperCase()] = templateList[i];
  }
  const currentTemplateMap = templateMap[template_id];
  const input = [];
  for (let i = 0; i < formula.input.length; i++) {
    switch (typeof formula.input[i]) {
      case 'number':
      case 'string':
        input.push(JSON.stringify(formula.input[i]));
        break;
      case 'function':
        console.log(1);
      case 'object':
        if (formula.input[i] === null) {
          input.push(JSON.stringify(null));
        } else {
          switch (formula.input[i].type) {
            case 'cas_prop':
              input.push(`CAS_PROP({${currentTemplateMap?.prop?.[formula.input[i].prop]?.name}}, '${formula.input[i].split}')`);
              break;
            case 'cas_prop_n':
              input.push(`CAS_PROP_N({${currentTemplateMap?.prop?.[formula.input[i].prop]?.name}}, ${formula.input[i].level})`);
              break;
            case 'prop':
              switch (formula.input[i].prop) {
                case -3:
                  input.push('{标题}');
                  break;
                case -1:
                  input.push('{创建者}');
                  break;
                default:
                  input.push(`{${currentTemplateMap?.prop?.[formula.input[i].prop]?.name}}`);
              }
              break;
            case 'create_time':
              input.push('{创建时间}');
              break;
            case 's_prop':
              input.push(`{${statusPropMap[formula.input[i].prop]}}`);
              break;
            case 'const':
              input.push(`CONST(${JSON.stringify(formula.input[i].const)})`);
              break;
            case 'now':
              input.push(`{当前时间}`);
              break;
            case 'node_id':
            case 'node_seq':
              input.push(`${formula.input[i].type.toUpperCase()}()`);
              break;
            case 'formula':
              if (formula.op in opLevel && formula.input[i].formula.op in opLevel && i === 0 ? opLevel[formula.input[i].formula.op] > opLevel[formula.op] : opLevel[formula.input[i].formula.op] >= opLevel[formula.op]) {
                input.push(`(${formulaToString(formula.input[i].formula, templateList, template_id)})`);
              } else {
                input.push(formulaToString(formula.input[i].formula, templateList, template_id));
              }
              break;
            case 'quota':
              input.push(`QUOTA({${templateMap[formula.input[i].temp_id].name}},[${formula.input[i].prop.map(n => `{${currentTemplateMap?.prop?.[n]?.name}}`).join(',')}],[${formula.input[i].remoteProp.map(n => `{${templateMap[formula.input[i].temp_id]?.prop?.[n]?.name}}`).join(',')}],{${templateMap[formula.input[i].temp_id]?.prop?.[formula.input[i].quotaProp]?.name}},${Array.isArray(formula.input[i].si) ? `[${formula.input[i].si.map(n => `{${templateMap[formula.input[i].temp_id]?.task_status?.[n]?.name}}`).join(',')}]` : null})`);
              break;
            case 'immediate':
              input.push('IMM()');
              break;
          }
        }
    }
  }
  let op;
  switch (formula.op) {
    case 'add':
      return `${input[0]}+${input[1]}`;
    case 'subtract':
      return `${input[0]}-${input[1]}`;
    case 'multiply':
      return `${input[0]}*${input[1]}`;
    case 'divide':
      return `${input[0]}/${input[1]}`;
    case 'mod':
      return `${input[0]}%${input[1]}`;
    case 'great':
      return `${input[0]}>${input[1]}`;
    case 'less':
      return `${input[0]}<${input[1]}`;
    case 'great_equal':
      return `${input[0]}>=${input[1]}`;
    case 'less_equal':
      return `${input[0]}<=${input[1]}`;
    case 'equal':
      return `${input[0]}==${input[1]}`;
    case 'not_equal':
      return `${input[0]}!=${input[1]}`;
    case 'nick_name':
      if (input.length === 1) {
        return input[0];
      }
      break;
    case 'date':
      try {
        const input1 = JSON.parse(input[1]);
        if (input1 in DateFormulaMap) input[1] = JSON.stringify(DateFormulaMap[input1]);
      } catch (e) {}
      op = 'DATE';
      break;
    case 'random':
      op = 'RAND';
      break;
    case 'h_to_i':
      op = 'HEX_TO_INT';
      break;
    case 'i_to_s':
      op = 'INT_TO_STRING';
      break;
    default:
      op = formula.op;
  }
  return `${op.toUpperCase()}(${input.join(',')})`;
}